import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { get, isEmpty } from "lodash";
import {
  ManagePlanLayout,
  AddPlans,
  CsplTable as Table,
  LoaderWrapper,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import { useRouterParams, useRequest } from "../../../abstracts";
import { clearLocalCacheByModel, createPlanStore } from "../../../contexts";
import { listVesting } from "../../../services";

const columns = [
  {
    label: "Vesting Name",
    className: "column-source-name",
    columnName: "vestingName",
    link: `${MANAGE_PLAN_ROUTES.ADD_VESTING}`,
  },
  {
    label: "Vesting Method",
    className: "column-source-catergory",
    columnName: "vestingMethod",
    dataMapper: OPTIONS_DATA_MAPPER.VESTING_METHOD,
  },
];

const VestingContainer = (props) => {
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(createPlanStore);

  const { response: vestings, loading: isLoading } = useRequest({
    method: listVesting,
    payload: parseInt(planId),
    defaultResponse: [],
  });

  const vestingData = get(vestings, "vestings", []);

  // useEffect(() => {
  //   dispatch(clearLocalCacheByModel("vestings"));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onAddClick = () => {
    const { history } = props;

    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_VESTING,
        pathParam: [planId, FLOW_TYPES.ADD],
      })
    );
  };

  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
    // {
    //   label: "",
    //   variant: "secondary",
    //   type: "button",
    //   flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
    //   isAddButton: true,
    //   onClick: onAddClick,
    // },
  ];

  return (
    <LoaderWrapper isLoading={isLoading}>
      <ManagePlanLayout buttons={buttons} pageFlow={flow}>
        {isEmpty(vestingData) && (
          <AddPlans
            menu="plan"
            subMenu="vesting"
            content="No vesting rules."
            buttonLabel="Add Vesting"
            link={getPathWithParam({
              path: MANAGE_PLAN_ROUTES.ADD_VESTING,
              pathParam: [planId, FLOW_TYPES.ADD],
            })}
          />
        )}
        {!isEmpty(vestingData) && (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading font-weight-500">
                Manage Vesting
              </div>
            </div>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {vestingData.map((vesting, index) => {
                  return (
                    <Table.Tr key={index}>
                      {columns.map((item, cellIndex) => {
                        return (
                          <Table.Td key={cellIndex} className={item.className}>
                            {!isEmpty(item.link) ? (
                              <Link
                                to={getPathWithParam({
                                  path: item.link,
                                  pathParam: [
                                    FLOW_TYPES.EDIT,
                                    planId,
                                    vesting.id,
                                  ],
                                })}
                              >
                                {vesting[item.columnName]}
                              </Link>
                            ) : item.dataMapper ? (
                              get(
                                item.dataMapper,
                                vesting[item.columnName],
                                "Immediate"
                              )
                            ) : (
                              vesting[item.columnName]
                            )}
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        )}
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default VestingContainer;
